'use strict';

angular.module('licensure.services')
    .factory('FBPackages', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/FBPackages', {
                    params: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/FBPackages/' + id, {
                    params: {
                        
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (args) {
                var d = $q.defer();

                if (args.form_package == null) {
                    d.resolve(null);
                }
                else {
                    args.forms = args.form_package.forms
                }

                var method = 'POST';
                var url = apiLocation + '/api/FBPackages/';
                if (!isUndefined(args.form_package.id)) {
                    method = 'PUT'
                    url += args.form_package.id
                }

                $http({
                    method: method,
                    url: url,
                    data: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/FBPackages/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;